import React from 'react';
import '../styles/Page.css';

function Services() {
  return (
    <div className="page-container services-page">
      <div className="services-content">
        {/* Services content will be added here */}
      </div>
    </div>
  );
}

export default Services;
